function checkForIsBuilderEditing(): boolean {
  if (!global?.window) return false

  const searchParams = new URLSearchParams(global.window.location.search)
  return searchParams.get('__builder_editing__') === 'true'
}

export default checkForIsBuilderEditing
